tower.updateFavicon = (num) ->
  favicon = document.getElementById('favicon')
  faviconSize = 32

  canvas = document.createElement('canvas')
  canvas.width = faviconSize
  canvas.height = faviconSize

  context = canvas.getContext('2d')
  img = document.createElement('img')
  img.src = '/favicon-red.ico?v=2'

  if num == 0 || !num
    favicon.href = '/favicon.ico?v=2'
    return
  else if num > 99
    num = '···'

  img.onload = ->
    # Draw Original Favicon as Background
    context.drawImage img, 0, 0, faviconSize, faviconSize

    # Draw Notification Number
    context.font = '14px/1 Roboto, "Helvetica Neue", Helvetica, sans-serif'
    context.textAlign = 'center'
    context.textBaseline = 'middle'
    context.fillStyle = '#ffffff'
    context.fillText(num, 21, 8)

    # Replace favicon
    favicon.href = canvas.toDataURL('image/png')
